module.exports = __webpack_public_path__ + "media/images/bg-bonds1-23179b819de197068caf94f8a5ebcd01.jpg";